(ns app.front.view.admin.migration.remove-cashier-authz
  (:require [app.front.view.admin.migration.template :as admin-migration-template]
            [core.front.event :refer [>evt]]))

(defn view [match]
  [admin-migration-template/admin-page-for-migration
   {:task-id   :app.admin.migration.task/remove-extra-cashier-authz
    :title     "Remove extra cashier authorizations from workspaces that are not visible to the group"
    :help-text (str "This migration removes extra cashier authorizations from workspaces that are not visible to the group, "
                    "for example draft applications. This is needed because of a bug in a previous migration added "
                    "authorization for the Cashiers user group to all workspaces.")}
   match])

(def route
  {:name        :view/admin.migration.remove-extra-cashier-authz
   :view        view
   :controllers [{:start (fn [_]
                           (>evt [::admin-migration-template/fetch-migration-tasks
                                  :app.admin.migration.task/remove-extra-cashier-authz]))}]})
